<template>
  <el-button
    :style="`background-color: ${estilo.aplicacao.corPrimariaAplicacao}14`"
    class="lista-servicos-button"
    round
    style="border-radius: 10px !important;"
    @click="$emit('click', contato)"
  >
    <div style="display:flex; flex-flow: row nowrap; align-items: center;">
      <div style="display:flex; flex-flow: column nowrap; row-gap: 16px; flex: 1;">
        <svgIcone
          :height="28"
          :width="28"
          :cor="estilo.aplicacao.corPrimariaAplicacao"
          :icone="contato.icone"
        />
        <span class="text-button"
          style="color: #000000"
        >
          {{ contato.descricao }}
        </span>
      </div>

      <div
        v-if="contato.tipo === 'grupo'"
        :style="`background-color: ${estilo.aplicacao.corPrimariaAplicacao}`"
        style="height: 26px; width: 1px;"
      />
    </div>
  </el-button>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FuncionalidadeBtn',
  props: {
    contato: {}
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo'])
  }
}
</script>
<style scoped>

.lista-servicos-button {
  width: 298px;
  height: 86px;
  text-align: left;
  margin-left: 0;
  margin-bottom: 10px;
  text-transform: none;
  font-weight: 500;
  font-size: 14px;
  margin-right: 10px;
  display: inline-block;
  border: none;
  font-family: "Open Sans";
  color: #000000;
  padding: 16px;
  white-space: normal;
}
.text-button {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
  height: 16px;
}
</style>
